import request from '@/utils/request'

/**
 * 查询商圈菜单列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getHousekeepingTypeList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.queryHousekeepingType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存产品菜单
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveProductMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productMenu.saveProductMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新商城菜单
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateMallMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productMenu.updateMallMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询店铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询家政服务列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAdminServ(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.queryAdminServ',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
export function deleteMallMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productMenu.deleteMallMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
